module.exports = __webpack_public_path__ + "static/feature-1-1120264c983bd00798f3005ed2ed5ffa.svg";